import { ErrorHandler, InjectionToken, Provider } from '@angular/core';
import { ISentryConfiguration } from '@environments/environment-model';
import { init } from '@sentry/browser';
import { SentryErrorHandler } from './sentry.handler';

export const SENTRY_CONFIG = new InjectionToken<ISentryConfiguration>('SENTRY_CONFIG');

export function provideSentry(options: ISentryConfiguration): Provider[] {
    if (options.enabled) {
        init(options);
    }

    return [
        ...(options.enabled
            ? [
                  {
                      provide: ErrorHandler,
                      useClass: SentryErrorHandler,
                  },
              ]
            : []),
        {
            provide: SENTRY_CONFIG,
            useValue: options,
        },
    ];
}
